<template>
  <div class="allHomeContent">
    <div class="content">
      <div class="allContent">
        <div class="textPart">
          <!-- {{ UserProfile }} -->
          <img src="../assets/Welcomes.png" alt="" />
          <h1>
            Bienvenue sur votre espace de travail {{ UserProfile.fullName }} (
            {{ UserProfile.role }} )
          </h1>
        </div>
        <div
          v-if="
            UserProfile.role == 'Caisse' ||
            UserProfile.role == 'Administrateur' ||
            UserProfile.role == 'Responsable financier'
          "
          class="wallet"
        >
          <div class="grid-container">
            <div v-for="(item, index) in tableHeader" :key="index" class="card">
              <span class="title"> {{ item }}</span>
              <span class="price">
                {{
                  UserProfile.wallets && UserProfile.wallets.paymentMethods && UserProfile.wallets.paymentMethods[index]
                    ? UserProfile.wallets.paymentMethods[index].balance
                    : 0
                }}
                FCFA</span
              >
            </div>
          </div>
        </div>
        <div v-else class="wallet">
          <div class="grid-container">
            <div
              v-for="(item, index) in soreStockData"
              :key="index"
              class="card"
            >
              <span class="title">
                {{
                  item.product
                    ? item.product.name + " (" + item.product.type + ")"
                    : "---"
                }}</span
              >

              <span class="price">
                {{ item.product ? item.product.unitPrice : 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="UserProfile.role == 'Administrateur'" class="content">
      <div class="contentLeft">
        <!-- <div class="welcomContent"></div> -->
        <div class="graphHystory">
          <span class="chartLabelTitle">Total Revenu</span>
          <!-- // line, area, bar, pie, donut, scatter, bubble, heatmap, radialBar, candlestick   -->
      <apexchart
            width="100%"
            height="90%"
            type="area"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
        <div class="otherStatGraph">
          <div class="contentOtherStatGraph">
            <span class="chartLabelTitle">Produit mieux vendu</span>
            <span class="price">-- --- --- Produit vendu</span>
            <div class="contentLists">
              <table class="contentListeTable">
                <thead>
                  <tr>
                    <th></th>
                    <th>Caractéristique Du Produit</th>
                    <th>Quantité Vendue</th>
                    <th>Quantité Restante</th>
                    <th>Montant Total Ventes</th>
                    <th>Taux</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tableData" :key="item.name">
                    <td>
                      <div class="imgeProduct">
                        <span class="material-icons-sharp"> inventory_2 </span>
                      </div>
                    </td>
                    <td>
                      <div class="nameContent">
                        <span class="productTitle">{{ item.name }}</span>
                        <span class="productType">{{ item.type }}</span>
                      </div>
                    </td>
                    <td>{{ "-- ---" }}</td>
                    <td>{{ "-- ---" }}</td>
                    <td>{{ "-- --- --- --- 0 F cfa" }}</td>
                    <td>
                      <div class="cardRate">
                        <div class="icon">
                          <span class="material-icons-sharp">
                            expand_less
                          </span>
                        </div>
                        <div class="value">+ 0%</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="contentRight">
        <div class="listCard">
          <div class="miniCard">
            <div class="cardIcon">
              <span class="material-icons-sharp"> trending_up </span>
            </div>
            <div class="cardTitle">Profits</div>
            <div class="cardAmount">-- --- --- --- 0 F cfa</div>
            <div class="cardRate">
              <div class="icon">
                <span class="material-icons-sharp"> expand_less </span>
              </div>
              <div class="value">+ 0%</div>
            </div>
          </div>
          <div class="miniCard">
            <div class="cardIconBlue">
              <span class="material-icons-sharp"> account_balance_wallet </span>
            </div>
            <div class="cardTitle">Ventes</div>
            <div class="cardAmount">-- --- --- --- 0 F cfa</div>
            <div class="cardRate">
              <div class="icon">
                <span class="material-icons-sharp"> expand_less </span>
              </div>
              <div class="value">+ 0%</div>
            </div>
          </div>
          <div class="miniCard">
            <div class="cardIconRed">
              <span class="material-icons-sharp"> shopping_cart </span>
            </div>
            <div class="cardTitle">Paiement</div>
            <div class="cardAmount">-- --- --- --- 0 F cfa</div>
            <div class="cardRateRed">
              <div class="icon">
                <span class="material-icons-sharp"> keyboard_arrow_down </span>
              </div>
              <div class="value">+ 0%</div>
            </div>
          </div>
          <div class="miniCard">
            <div class="cardIconPurple">
              <span class="material-icons-sharp"> sync_alt </span>
            </div>
            <div class="cardTitle">Transaction</div>
            <div class="cardAmount">-- --- --- --- 0 F cfa</div>
            <div class="cardRate">
              <div class="icon">
                <span class="material-icons-sharp"> expand_less </span>
              </div>
              <div class="value">+ 0%</div>
            </div>
          </div>
        </div>
        <!-- <div class="profiHystory"></div> -->
        <div class="transactionHystory">
          <span class="chartLabelTitle"
            >Transactions Mensuelles Compte Client</span
          >
          <div class="rowElement">
            <span class="price">Crédit : -- --- --- ---0 F cfa</span>

            <span class="price">Débit : -- --- --- ---0 F cfa</span>
          </div>
          <div class="contentLists">
            <table class="contentListeTable">
              <thead>
                <tr>
                  <th></th>
                  <th>Motif</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableData" :key="item.name">
                  <td>
                    <div class="nameContent">
                      <span class="productTitle">{{
                        "------ ------- ----"
                      }}</span>
                      <span class="productType">{{ "---- --------" }}</span>
                    </div>
                  </td>
                  <td>{{ "-----" }}</td>
                  <td>{{ "-- --- --- --- 0 F cfa" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ est un alias vers /src
import { mapActions, mapGetters } from "vuex";
 import VueApexCharts from "vue-apexcharts";
export default {
  name: "homeView",
  components: {
   apexchart: VueApexCharts,
  },
  data: () => ({
    tableHeader: [
      "Portefeuille",
      "Espèces",
      "À crédit",
      "Chèque",
      "Virement",
      // "Ristourne",
    ],
    chartOptions: {
      chart: {
        id: "vuechart-example",
        toolbar: {
          show: false,
        },
      },

      xaxis: {
        categories: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Aout",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
      },
    },
    series: [
      {
        name: "Chiffre d'affaires 2022",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Chiffre d'affaires 2023",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Chiffre d'affaires 2020",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    tableData: [
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },

      {
        name: "---",
        type: "--",
        sellQuantity: 0,
        stockQuantity: 0,
        totalAmount: 0,
      },
    ],
  }),
  computed: {
    ...mapGetters(["UserProfile", "soreStockData"]),
  },
  async mounted() {
    await this.getUserProfile();
    if (
      this.UserProfile.role != "Caisse" &&
      this.UserProfile.role != "Administrateur" &&
      this.UserProfile.role != "Responsable financier"
    ) {
      await this.getStoreStock({});
    }
  },
  methods: {
    ...mapActions(["getUserProfile", "getStoreStock"]),
  },
};
</script>
